export const PLANS_LIST = [
  {
    id: "1",
    code: "BASIC",
    name: "Basic",
    description: "Essential contract management features for basic operations",
    planType: "BASIC",
    moduleFeatures: [
      {
        moduleCode: "ORGANISATION",
        details: [
          {
            featureCode: "ORGANISATION"
          }
        ]
      },
      {
        moduleCode: "USER_MANAGEMENT",
        details: [
          {
            featureCode: "USER.ROLE.MANAGEMENT"
          }
        ]
      },
      {
        moduleCode: "DEPARTMENT",
        details: [
          {
            featureCode: "DEPARTMENT.MAIN"
          }
        ]
      },
      {
        moduleCode: "NOTIFICATIONS",
        details: [
          {
            featureCode: "NOTIFICATIONS"
          }
        ]
      },
      {
        moduleCode: "SYSTEM_LOG",
        details: [
          {
            featureCode: "SYSTEM_LOG"
          }
        ]
      },
      {
        moduleCode: "CONTRACT",
        details: [
          {
            featureCode: "CONTRACT.MAIN"
          },
          {
            featureCode: "CONTRACT.REVIEWS"
          }
        ]
      },
      {
        moduleCode: "CUSTOMER",
        details: [
          {
            featureCode: "CUSTOMER.BASIC"
          }
        ]
      },
      {
        moduleCode: "SUPPLIER",
        details: [
          {
            featureCode: "SUPPLIER.BASIC"
          }
        ]
      },
      {
        moduleCode: "REPORT",
        details: [
          {
            featureCode: "REPORT.PREDEFINED"
          }
        ]
      }
    ]
  },
  {
    id: "2",
    code: "PREMIUM",
    name: "Premium",
    description: "Full platform access with all modules and advanced features",
    planType: "PREMIUM",
    moduleFeatures: [
      {
        moduleCode: "ORGANISATION",
        details: [
          {
            featureCode: "ORGANISATION"
          }
        ]
      },
      {
        moduleCode: "USER_MANAGEMENT",
        details: [
          {
            featureCode: "USER.ROLE.MANAGEMENT"
          }
        ]
      },
      {
        moduleCode: "DEPARTMENT",
        details: [
          {
            featureCode: "DEPARTMENT.MAIN"
          }
        ]
      },
      {
        moduleCode: "NOTIFICATIONS",
        details: [
          {
            featureCode: "NOTIFICATIONS"
          }
        ]
      },
      {
        moduleCode: "SYSTEM_LOG",
        details: [
          {
            featureCode: "SYSTEM_LOG"
          }
        ]
      },
      {
        moduleCode: "CONTRACT",
        details: [
          {
            featureCode: "CONTRACT.MAIN"
          },
          {
            featureCode: "CONTRACT.REVIEWS"
          },
          {
            featureCode: "CONTRACT.TRANSACTION"
          },
          {
            featureCode: "CONTRACT.SLA"
          },
          {
            featureCode: "CONTRACT.PERFORMANCE"
          },
          {
            featureCode: "CONTRACT.CUSTOMER.REMARK"
          },
          {
            featureCode: "CONTRACT.COST.TRACKING"
          },
          {
            featureCode: "CONTRACT.TEMPLATE.BUILDER"
          }
        ]
      },
      {
        moduleCode: "CUSTOMER",
        details: [
          {
            featureCode: "CUSTOMER.BASIC"
          },
          {
            featureCode: "CUSTOMER.REVIEW_COMPLIANCE"
          }
        ]
      },
      {
        moduleCode: "SUPPLIER",
        details: [
          {
            featureCode: "SUPPLIER.BASIC"
          },
          {
            featureCode: "SUPPLIER.REVIEW_COMPLIANCE"
          }
        ]
      },
      {
        moduleCode: "REPORT",
        details: [
          {
            featureCode: "REPORT.PREDEFINED"
          },
          {
            featureCode: "REPORT.BUILDER"
          }
        ]
      },
      {
        moduleCode: "SERVICE_MANAGER",
        details: [
          {
            featureCode: "SERVICE.MANAGER.BASIC"
          },
          {
            featureCode: "SERVICE.COST.TRACKING"
          }
        ]
      },
      {
        moduleCode: "PERFORMANCE_TRACKER",
        details: [
          {
            featureCode: "PERFORMANCE.TRACKER.MAIN"
          }
        ]
      },
      {
        moduleCode: "COST_TRACKER",
        details: [
          {
            featureCode: "COST_TRACKER"
          }
        ]
      },
      {
        moduleCode: "SLA",
        details: [
          {
            featureCode: "SLA"
          }
        ]
      },
      {
        moduleCode: "KPI",
        details: [
          {
            featureCode: "KPI"
          }
        ]
      },
      {
        moduleCode: "CONNECTOR",
        details: [
          {
            featureCode: "CONNECTOR.BASIC"
          },
          {
            featureCode: "CONNECTOR.SAGE"
          }
        ]
      },
      {
        moduleCode: "DATA_VISUALISATION",
        details: [
          {
            featureCode: "DATA.VIZ.HIER"
          },
          {
            featureCode: "DATA.VIZ.COMPARISON"
          },
          {
            featureCode: "DATA.VIZ.SERVICE.PERF"
          }
        ]
      },
      {
        moduleCode: "CONTRACT_STUDIO",
        details: [
          {
            featureCode: "CONTRACT.TEMPLATE.BUILDER"
          }
        ]
      },
      {
        moduleCode: "CONTRACT_CAPTURE",
        details: [
          {
            featureCode: "CONTRACT.AI.EXTRACTION"
          }
        ]
      }
    ]
  },
  {
    id: "3",
    code: "CUSTOM_ONE",
    name: "Custom 101",
    description: "Essential contract management features for basic operations",
    planType: "CUSTOM",
    moduleFeatures: [
      {
        moduleCode: "ORGANISATION",
        details: [
          {
            featureCode: "ORGANISATION"
          }
        ]
      },
      {
        moduleCode: "USER_MANAGEMENT",
        details: [
          {
            featureCode: "USER.ROLE.MANAGEMENT"
          }
        ]
      },
      {
        moduleCode: "DEPARTMENT",
        details: [
          {
            featureCode: "DEPARTMENT.MAIN"
          }
        ]
      },
      {
        moduleCode: "NOTIFICATIONS",
        details: [
          {
            featureCode: "NOTIFICATIONS"
          }
        ]
      },
      {
        moduleCode: "SYSTEM_LOG",
        details: [
          {
            featureCode: "SYSTEM_LOG"
          }
        ]
      },
      {
        moduleCode: "CONTRACT",
        details: [
          {
            featureCode: "CONTRACT.MAIN"
          },
          {
            featureCode: "CONTRACT.REVIEWS"
          }
        ]
      },
      {
        moduleCode: "CUSTOMER",
        details: [
          {
            featureCode: "CUSTOMER.BASIC"
          }
        ]
      },
      {
        moduleCode: "SUPPLIER",
        details: [
          {
            featureCode: "SUPPLIER.BASIC"
          }
        ]
      },
      {
        moduleCode: "REPORT",
        details: [
          {
            featureCode: "REPORT.PREDEFINED"
          }
        ]
      }
    ]
  }
];

export const ALL_MODULES_AND_FEATURES_LIST = [
  {
    id: "69961bfb266212236d5c1805",
    code: "ORGANISATION",
    name: "Organisation",
    description: "Organisation setup and management",
    isMandatory: true,
    features: [
      {
        id: "69961c0a266212236d5c1832",
        moduleId: "69961bfb266212236d5c1805",
        moduleCode: "ORGANISATION",
        code: "ORGANISATION",
        name: "Basic Organisation Management",
        description: "Basic Organisation Management",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "ORGANISATION.ORGANISATION.OVERVIEW",
            tabDisplayName: "Overview",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "ORGANISATION.ORGANISATION.CATALOG",
            tabDisplayName: "Catalogs",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "ORGANISATION.ORGANISATION.TEMPLATE",
            tabDisplayName: "Templates",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "ORGANISATION.ORGANISATION.SUPPLIER_DOCUMENTS",
            tabDisplayName: "Supplier Documents",
            displayOrder: 4,
            icon: null
          },
          {
            tabName: "ORGANISATION.ORGANISATION.SETTINGS",
            tabDisplayName: "Settings",
            displayOrder: 5,
            icon: null
          },
          {
            tabName: "ORGANISATION.ORGANISATION.ROLES_AND_PERMISSIONS",
            tabDisplayName: "Roles and Permissions",
            displayOrder: 6,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfb266212236d5c1806",
    code: "USER_MANAGEMENT",
    name: "User Management",
    description: "User and role management",
    isMandatory: true,
    features: [
      {
        id: "69961c0b266212236d5c1833",
        moduleId: "69961bfb266212236d5c1806",
        moduleCode: "USER_MANAGEMENT",
        code: "USER_ROLE_MANAGEMENT",
        name: "User & Role Management",
        description: "User & Role Management",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "USER_MANAGEMENT.USER_ROLE_MANAGEMENT.MAIN",
            tabDisplayName: "User Management",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfc266212236d5c1807",
    code: "CONTRACT",
    name: "Contract",
    description: "End-to-end contract lifecycle management",
    isMandatory: true,
    features: [
      {
        id: "69961c02266212236d5c181b",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_MAIN",
        name: "Basic Contract Lifecycle",
        description: "Basic Contract Lifecycle",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_MAIN.MAIN",
            tabDisplayName: "Contract",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_MAIN.FILES",
            tabDisplayName: "Files",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_MAIN.SELL_DETAILS",
            tabDisplayName: "Sell Details",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_MAIN.PROCUREMENT",
            tabDisplayName: "Procurement",
            displayOrder: 4,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_MAIN.NOTES",
            tabDisplayName: "Notes",
            displayOrder: 5,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_MAIN.TIMELINE",
            tabDisplayName: "Timeline",
            displayOrder: 6,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Basic Contract Lifecycle requires Department",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180e",
            dependsOnModuleCode: "NOTIFICATION",
            description: "Basic Contract Lifecycle requires Notification",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Sell Side Contract requires Customer",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Buy Side Contract requires Supplier",
            isMandatory: false
          }
        ],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c03266212236d5c181c",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_REVIEWS",
        name: "Contract Reviews & Renewals",
        description: "Contract Reviews & Renewals",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_REVIEWS.REVIEW",
            tabDisplayName: "Reviews",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c03266212236d5c181d",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_TRANSACTION",
        name: "Contract Transaction",
        description: "Contract Transaction",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_TRANSACTION.TRANSACTION",
            tabDisplayName: "Transaction",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961c01266212236d5c1817",
            dependsOnModuleCode: "CONNECTOR",
            description: "Contract Transaction requires Connector",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c03266212236d5c181e",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_SLA",
        name: "SLA Tracking",
        description: "SLA Tracking",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_SLA.OPERATIONAL",
            tabDisplayName: "Operational",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CONTRACT.CONTRACT_SLA.SLA_LOGS",
            tabDisplayName: "SLA Logs",
            displayOrder: 2,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961c00266212236d5c1815",
            dependsOnModuleCode: "SLA",
            description: "SLA Tracking requires SLA",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c01266212236d5c1816",
            dependsOnModuleCode: "KPI",
            description: "SLA Tracking requires KPI",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c01266212236d5c1817",
            dependsOnModuleCode: "CONNECTOR",
            description: "SLA Tracking requires Connector",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c04266212236d5c181f",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_PERFORMANCE",
        name: "Performance Tracking",
        description: "Performance Tracking",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_PERFORMANCE.TRACKING",
            tabDisplayName: "Tracking",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c04266212236d5c1820",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_CUSTOMER_REMARK",
        name: "Customer Remark",
        description: "Customer Remark",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_CUSTOMER_REMARK.CUSTOMER_REMARK",
            tabDisplayName: "Customer Remarks",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Customer Remark requires Customer",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c04266212236d5c1821",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_COST_TRACKING",
        name: "Cost Tracking",
        description: "Cost Tracking",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT.CONTRACT_COST_TRACKING.COST_TRACKING",
            tabDisplayName: "Cost Tracking",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Cost Tracking requires Customer",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69afc308640c6a2fd0e75a27",
            dependsOnModuleCode: "COST_CENTER",
            description: "Cost Tracking requires Cost Center",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Cost Tracking requires Department",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c01266212236d5c1817",
            dependsOnModuleCode: "CONNECTOR",
            description: "Cost Tracking requires Connectors",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bff266212236d5c1811",
            dependsOnModuleCode: "COST_TRACKER",
            description: "Cost Tracking requires Cost Tracker",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "699ff6a7d2ccc41bec310fe7",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_BUY",
        name: "Contract Buy",
        description: "Buy Contract Type",
        featureType: "DROPDOWN",
        tabMappings: [],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Buy Contract requires Supplier",
            isMandatory: true
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "699ff6a8d2ccc41bec310fe8",
        moduleId: "69961bfc266212236d5c1807",
        moduleCode: "CONTRACT",
        code: "CONTRACT_SELL",
        name: "Contract Sell",
        description: "Sell Contract Type",
        featureType: "DROPDOWN",
        tabMappings: [],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Sell Contract requires Customer",
            isMandatory: true
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfc266212236d5c1808",
    code: "CONTRACT_STUDIO",
    name: "Contract Studio",
    description: "Contract template and builder",
    isMandatory: false,
    features: [
      {
        id: "69961c05266212236d5c1822",
        moduleId: "69961bfc266212236d5c1808",
        moduleCode: "CONTRACT_STUDIO",
        code: "CONTRACT_TEMPLATE_BUILDER",
        name: "Contract Template & Builder",
        description: "Contract Template & Builder",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT_STUDIO.CONTRACT_TEMPLATE_BUILDER.TEMPLATE",
            tabDisplayName: "Contract Template",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CONTRACT_STUDIO.CONTRACT_TEMPLATE_BUILDER.BUILDER",
            tabDisplayName: "Contract Builder",
            displayOrder: 2,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Contract Template & Builder requires Customer",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfc266212236d5c1809",
    code: "CONTRACT_CAPTURE",
    name: "Contract Capture",
    description: "AI-powered contract extraction",
    isMandatory: false,
    features: [
      {
        id: "69961c05266212236d5c1824",
        moduleId: "69961bfc266212236d5c1809",
        moduleCode: "CONTRACT_CAPTURE",
        code: "CONTRACT_AI_EXTRACTION",
        name: "Contract Extraction from Document",
        description: "Contract Extraction from Document",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CONTRACT_CAPTURE.CONTRACT_AI_EXTRACTION.DETAILS",
            tabDisplayName: "Details",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CONTRACT_CAPTURE.CONTRACT_AI_EXTRACTION.EXTRACTION",
            tabDisplayName: "Extraction",
            displayOrder: 2,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfd266212236d5c180a",
    code: "CUSTOMER",
    name: "Customer",
    description: "Customer management and billing",
    isMandatory: false,
    features: [
      {
        id: "69961c06266212236d5c1825",
        moduleId: "69961bfd266212236d5c180a",
        moduleCode: "CUSTOMER",
        code: "CUSTOMER_BASIC",
        name: "Basic Customer",
        description: "Basic Customer",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CUSTOMER.CUSTOMER_BASIC.MAIN",
            tabDisplayName: "Customer",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CUSTOMER.CUSTOMER_BASIC.FINANCIAL",
            tabDisplayName: "Financial",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "CUSTOMER.CUSTOMER_BASIC.BILLING",
            tabDisplayName: "Billing",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "CUSTOMER.CUSTOMER_BASIC.CONTRACTS",
            tabDisplayName: "contracts",
            displayOrder: 4,
            icon: null
          },
          {
            tabName: "CUSTOMER.CUSTOMER_BASIC.INVOICE_PROFILE",
            tabDisplayName: "Invoice Profile",
            displayOrder: 5,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Basic Customer requires Department",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180e",
            dependsOnModuleCode: "NOTIFICATION",
            description: "Basic Customer requires Notification",
            isMandatory: true
          }
        ],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c06266212236d5c1826",
        moduleId: "69961bfd266212236d5c180a",
        moduleCode: "CUSTOMER",
        code: "CUSTOMER_REVIEW_COMPLIANCE",
        name: "Review & Compliance",
        description: "Review & Compliance",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CUSTOMER.CUSTOMER_REVIEW_COMPLIANCE.REVIEW",
            tabDisplayName: "Review",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "CUSTOMER.CUSTOMER_REVIEW_COMPLIANCE.COMPLIANCE",
            tabDisplayName: "Compliance",
            displayOrder: 2,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfd266212236d5c180b",
    code: "SUPPLIER",
    name: "Supplier",
    description: "Supplier management and compliance",
    isMandatory: false,
    features: [
      {
        id: "69961c07266212236d5c1827",
        moduleId: "69961bfd266212236d5c180b",
        moduleCode: "SUPPLIER",
        code: "SUPPLIER_BASIC",
        name: "Basic Supplier",
        description: "Basic Supplier",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "SUPPLIER.SUPPLIER_BASIC.MAIN",
            tabDisplayName: "Supplier",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "SUPPLIER.SUPPLIER_BASIC.FINANCIAL",
            tabDisplayName: "Financial",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "SUPPLIER.SUPPLIER_BASIC.CONTACTS",
            tabDisplayName: "Contacts",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "SUPPLIER.SUPPLIER_BASIC.SUPPLIER_DOCUMENTS",
            tabDisplayName: "Supplier Documents",
            displayOrder: 4,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Basic Supplier requires Department",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180e",
            dependsOnModuleCode: "NOTIFICATION",
            description: "Basic Supplier requires Notification",
            isMandatory: true
          }
        ],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c07266212236d5c1828",
        moduleId: "69961bfd266212236d5c180b",
        moduleCode: "SUPPLIER",
        code: "SUPPLIER_REVIEW_COMPLIANCE",
        name: "Review & Compliance",
        description: "Review & Compliance",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "SUPPLIER.SUPPLIER_REVIEW_COMPLIANCE.REVIEW",
            tabDisplayName: "Review",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "SUPPLIER.SUPPLIER_REVIEW_COMPLIANCE.COMPLIANCE",
            tabDisplayName: "Compliance",
            displayOrder: 2,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfd266212236d5c180c",
    code: "SERVICE_MANAGER",
    name: "Service Manager",
    description: "Service management and tracking",
    isMandatory: false,
    features: [
      {
        id: "69961c07266212236d5c1829",
        moduleId: "69961bfd266212236d5c180c",
        moduleCode: "SERVICE_MANAGER",
        code: "SERVICE_MANAGER_BASIC",
        name: "Basic Service Manager",
        description: "Basic Service Manager",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.MAIN",
            tabDisplayName: "Service Manager",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.REVIEW",
            tabDisplayName: "Reviews",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.SERVICE",
            tabDisplayName: "Service",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.NOTES",
            tabDisplayName: "Notes",
            displayOrder: 4,
            icon: null
          },
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.TIMELINE",
            tabDisplayName: "Timeline",
            displayOrder: 5,
            icon: null
          },
          {
            tabName: "SERVICE_MANAGER.SERVICE_MANAGER_BASIC.SERVICE_FLOW",
            tabDisplayName: "Service Flow",
            displayOrder: 6,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfe266212236d5c180e",
            dependsOnModuleCode: "NOTIFICATION",
            description: "Basic Customer requires Notification",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Basic Service Manager requires Contract",
            isMandatory: true
          }
        ],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c08266212236d5c182a",
        moduleId: "69961bfd266212236d5c180c",
        moduleCode: "SERVICE_MANAGER",
        code: "SERVICE_COST_TRACKING",
        name: "Service Cost Tracking",
        description: "Service Cost Tracking",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "SERVICE_MANAGER.SERVICE_COST_TRACKING.COST_TRACKING",
            tabDisplayName: "Cost Tracking",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bff266212236d5c1811",
            dependsOnModuleCode: "COST_TRACKER",
            description: "Service Cost Tracking requires Cost Center",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfe266212236d5c180d",
    code: "DEPARTMENT",
    name: "Department",
    description: "Department management",
    isMandatory: true,
    features: [
      {
        id: "69961c08266212236d5c182b",
        moduleId: "69961bfe266212236d5c180d",
        moduleCode: "DEPARTMENT",
        code: "DEPARTMENT_MAIN",
        name: "Department Management",
        description: "Department Management",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DEPARTMENT.DEPARTMENT_MAIN.MAIN",
            tabDisplayName: "Department",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfe266212236d5c180e",
    code: "NOTIFICATION",
    name: "Notification",
    description: "Notification management",
    isMandatory: true,
    features: [
      {
        id: "69961c0d266212236d5c1839",
        moduleId: "69961bfe266212236d5c180e",
        moduleCode: "NOTIFICATION",
        code: "NOTIFICATION",
        name: "Notification Management",
        description: "Notification Management",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "NOTIFICATION.NOTIFICATION.MAIN",
            tabDisplayName: "Notifications",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bfe266212236d5c180f",
    code: "REPORT",
    name: "Report",
    description: "Reporting and analytics",
    isMandatory: false,
    features: [
      {
        id: "69961c09266212236d5c182d",
        moduleId: "69961bfe266212236d5c180f",
        moduleCode: "REPORT",
        code: "REPORT_PREDEFINED",
        name: "Pre-defined Report",
        description: "Pre-defined Report",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "REPORT.REPORT_PREDEFINED.MAIN",
            tabDisplayName: "Predefined Report",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Pre-defined Report requires CONTRACT",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Pre-defined Report requires CUSTOMER",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Pre-defined Report requires DEPARTMENT",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfb266212236d5c1805",
            dependsOnModuleCode: "ORGANISATION",
            description: "Pre-defined Report requires ORGANISATION",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Pre-defined Report requires SERVICE MANAGER",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Pre-defined Report requires SUPPLIER",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c09266212236d5c182e",
        moduleId: "69961bfe266212236d5c180f",
        moduleCode: "REPORT",
        code: "REPORT_BUILDER",
        name: "Report Builder",
        description: "Report Builder",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "REPORT.REPORT_BUILDER.MAIN",
            tabDisplayName: "Report Builder",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Report Builder requires CONTRACT",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Report Builder requires CUSTOMER",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfe266212236d5c180d",
            dependsOnModuleCode: "DEPARTMENT",
            description: "Report Builder requires DEPARTMENT",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfb266212236d5c1805",
            dependsOnModuleCode: "ORGANISATION",
            description: "Report Builder requires ORGANISATION",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Report Builder requires SERVICE MANAGER",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Report Builder requires SUPPLIER",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c02266212236d5c1819",
            dependsOnModuleCode: "GOVERNANCE",
            description: "Report Builder requires GOVERNANCE",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bff266212236d5c1810",
    code: "DATA_VISUALISATION",
    name: "Data Visualisation",
    description: "Data visualization and dashboards",
    isMandatory: false,
    features: [
      {
        id: "69961c09266212236d5c182f",
        moduleId: "69961bff266212236d5c1810",
        moduleCode: "DATA_VISUALISATION",
        code: "DATA_VIZ_HIER",
        name: "Hierarchical View",
        description: "Hierarchical View",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DATA_VISUALISATION.DATA_VIZ_HIER.MAIN",
            tabDisplayName: "Hierarchical View",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961c00266212236d5c1815",
            dependsOnModuleCode: "SLA",
            description: "Hierarchical View requires SLA",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c01266212236d5c1816",
            dependsOnModuleCode: "KPI",
            description: "Hierarchical View requires KPI",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Hierarchical View requires Supplier",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Hierarchical View requires Contract",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Hierarchical View requires Service manager",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c0a266212236d5c1830",
        moduleId: "69961bff266212236d5c1810",
        moduleCode: "DATA_VISUALISATION",
        code: "DATA_VIZ_COMPARISON",
        name: "Comparison View",
        description: "Comparison View",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DATA_VISUALISATION.DATA_VIZ_COMPARISON.MAIN",
            tabDisplayName: "Comparison View",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Hierarchical View requires Supplier",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Hierarchical View requires Contract",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Hierarchical View requires Service manager",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c0a266212236d5c1831",
        moduleId: "69961bff266212236d5c1810",
        moduleCode: "DATA_VISUALISATION",
        code: "DATA_VIZ_SERVICE_PERF",
        name: "Service Performance View",
        description: "Service Performance View",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DATA_VISUALISATION.DATA_VIZ_SERVICE_PERF.MAIN",
            tabDisplayName: "Service Performance View",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Hierarchical View requires Contract",
            isMandatory: true
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bff266212236d5c1811",
    code: "COST_TRACKER",
    name: "Cost Tracker",
    description: "Cost tracking and management",
    isMandatory: false,
    features: [
      {
        id: "69961c0c266212236d5c1836",
        moduleId: "69961bff266212236d5c1811",
        moduleCode: "COST_TRACKER",
        code: "COST_TRACKER",
        name: "Cost Tracker",
        description: "Cost Tracker",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "COST_TRACKER.COST_TRACKER.MAIN",
            tabDisplayName: "Cost Tracker",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961bff266212236d5c1812",
    code: "PERFORMANCE_TRACKER",
    name: "Performance Tracker",
    description: "Performance tracking",
    isMandatory: false,
    features: [
      {
        id: "69961c08266212236d5c182c",
        moduleId: "69961bff266212236d5c1812",
        moduleCode: "PERFORMANCE_TRACKER",
        code: "PERFORMANCE_TRACKER_MAIN",
        name: "Performance Tracker Main",
        description: "Performance Tracker Main",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "PERFORMANCE_TRACKER.PERFORMANCE_TRACKER_MAIN.MAIN",
            tabDisplayName: "Performance Tracker",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c00266212236d5c1815",
    code: "SLA",
    name: "SLA",
    description: "Service Level Agreement management",
    isMandatory: false,
    features: [
      {
        id: "69961c0b266212236d5c1834",
        moduleId: "69961c00266212236d5c1815",
        moduleCode: "SLA",
        code: "SLA",
        name: "SLA MAIN",
        description: "SLA MAIN",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "SLA.SLA.MAIN",
            tabDisplayName: "SLA",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c01266212236d5c1816",
    code: "KPI",
    name: "KPI",
    description: "Key Performance Indicator management",
    isMandatory: false,
    features: [
      {
        id: "69961c0b266212236d5c1835",
        moduleId: "69961c01266212236d5c1816",
        moduleCode: "KPI",
        code: "KPI",
        name: "KPI MAIN",
        description: "KPI MAIN",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "KPI.KPI.MAIN",
            tabDisplayName: "KPI",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c01266212236d5c1817",
    code: "CONNECTOR",
    name: "Connector",
    description: "Integration connectors",
    isMandatory: false,
    features: [
      {
        id: "69961c0c266212236d5c1837",
        moduleId: "69961c01266212236d5c1817",
        moduleCode: "CONNECTOR",
        code: "CONNECTOR_BASIC",
        name: "Basic Connector",
        description: "Basic Connector",
        featureType: "DROPDOWN",
        tabMappings: [
          {
            tabName: "CONNECTOR.CONNECTOR_BASIC.MAIN",
            tabDisplayName: "Connector",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69961c0c266212236d5c1838",
        moduleId: "69961c01266212236d5c1817",
        moduleCode: "CONNECTOR",
        code: "CONNECTOR_SAGE",
        name: "iServe Connector",
        description: "iServe Connector",
        featureType: "DROPDOWN",
        tabMappings: [
          {
            tabName: "CONNECTOR.CONNECTOR_SAGE.MAIN",
            tabDisplayName: "Connector",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfe266212236d5c180e",
            dependsOnModuleCode: "NOTIFICATION",
            description: "iServe Connector requires Notification",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c01266212236d5c1818",
    code: "DASHBOARD",
    name: "Dashboard",
    description: "Dashboard views",
    isMandatory: false,
    features: [
      {
        id: "69a1979367e20a2566eda2c6",
        moduleId: "69961c01266212236d5c1818",
        moduleCode: "DASHBOARD",
        code: "DASHBOARD_CONTRACT",
        name: "Dashboard CONTRACT",
        description: "Dashboard CONTRACT",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.TOTAL",
            tabDisplayName: "Total Contracts",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.EXPIRING",
            tabDisplayName: "Expiring Contracts",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.PENDING",
            tabDisplayName: "Pending Contracts",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.RECEIVED",
            tabDisplayName: "Received Contracts",
            displayOrder: 4,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.PERFORMANCE",
            tabDisplayName: "Contract Performance",
            displayOrder: 5,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_CONTRACT.SIGNATURE_STATUS",
            tabDisplayName: "Contract Signature Status",
            displayOrder: 6,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Contract Dashboard requires Contract module",
            isMandatory: true
          }
        ],
        isMandatory: true,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69a1979367e20a2566eda2c7",
        moduleId: "69961c01266212236d5c1818",
        moduleCode: "DASHBOARD",
        code: "DASHBOARD_SERVICE",
        name: "Dashboard SERVICE",
        description: "Dashboard SERVICE",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DASHBOARD.DASHBOARD_SERVICE.TOTAL",
            tabDisplayName: "Total Services",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_SERVICE.EXPIRING",
            tabDisplayName: "Expiring Services",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_SERVICE.PERFORMANCE",
            tabDisplayName: "Service Performance",
            displayOrder: 3,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Service Dashboard requires Service Manager module",
            isMandatory: true
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69a1979367e20a2566eda2c8",
        moduleId: "69961c01266212236d5c1818",
        moduleCode: "DASHBOARD",
        code: "DASHBOARD_RISK",
        name: "Dashboard RISK",
        description: "Dashboard RISK",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DASHBOARD.DASHBOARD_RISK.SUPPLIER",
            tabDisplayName: "Supplier Risk",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_RISK.CONTRACT",
            tabDisplayName: "Contract Risk",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_RISK.SERVICE",
            tabDisplayName: "Service Risk",
            displayOrder: 3,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Risk Dashboard requires Supplier module",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Risk Dashboard requires Contract module",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Risk Dashboard requires Service Manager module",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69a1979467e20a2566eda2c9",
        moduleId: "69961c01266212236d5c1818",
        moduleCode: "DASHBOARD",
        code: "DASHBOARD_TOPFIVE",
        name: "Dashboard TOPFIVE",
        description: "Dashboard TOPFIVE",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DASHBOARD.DASHBOARD_TOPFIVE.SERVICE",
            tabDisplayName: "Top 5 Services",
            displayOrder: 1,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_TOPFIVE.SUPPLIER",
            tabDisplayName: "Top 5 Suppliers",
            displayOrder: 2,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_TOPFIVE.CONSUMPTION",
            tabDisplayName: "Top 5 Consumption",
            displayOrder: 3,
            icon: null
          },
          {
            tabName: "DASHBOARD.DASHBOARD_TOPFIVE.SLA",
            tabDisplayName: "Top 5 SLA",
            displayOrder: 4,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961c00266212236d5c1815",
            dependsOnModuleCode: "SLA",
            description: "Top 5 Dashboard requires SLA module",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Top 5 Dashboard requires Supplier module",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69afc308640c6a2fd0e75a27",
            dependsOnModuleCode: "COST_CENTER",
            description: "Top 5 Dashboard requires Cost Center module",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Top 5 Dashboard requires Service Manager module",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c02266212236d5c1819",
    code: "GOVERNANCE",
    name: "Governance",
    description: "Governance and compliance",
    isMandatory: false,
    features: [
      {
        id: "69a6910d750f2d0bbe6513f7",
        moduleId: "69961c02266212236d5c1819",
        moduleCode: "GOVERNANCE",
        code: "GOVERNANCE",
        name: "Governance",
        description: "Governance",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "GOVERNANCE.GOVERNANCE.MAIN",
            tabDisplayName: "Governance",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69961c02266212236d5c181a",
    code: "CCR",
    name: "CCR",
    description: "Contract Change Request",
    isMandatory: false,
    features: [
      {
        id: "69a6910b750f2d0bbe6513f3",
        moduleId: "69961c02266212236d5c181a",
        moduleCode: "CCR",
        code: "CONTRACT_CHANGE_REQUEST",
        name: "CCR",
        description: "Request to update contract end date/ value",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "CCR.CONTRACT_CHANGE_REQUEST.MAIN",
            tabDisplayName: "Contract Change Request",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Contract is required to update contract end date",
            isMandatory: true
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "699833fc15a60152068ef07b",
    code: "PLAN",
    name: "PLAN",
    description: "Subscription plan management",
    isMandatory: false,
    features: [
      {
        id: "699833fd15a60152068ef07c",
        moduleId: "699833fc15a60152068ef07b",
        moduleCode: "PLAN",
        code: "PLAN_MAIN",
        name: "Plan Management",
        description: "Subscription plan management",
        featureType: "TABS",
        tabsPermissions: ["PLAN.PLAN_MAIN.MAIN"],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a1978567e20a2566eda2c0",
    code: "ASKELIE",
    name: "ASKELIE",
    description: "ASKELIE AI assistant",
    isMandatory: false,
    features: [
      {
        id: "69a1979267e20a2566eda2c3",
        moduleId: "69a1978567e20a2566eda2c0",
        moduleCode: "ASKELIE",
        code: "ASKELIE_MAIN",
        name: "ASKELIE AI Assistant",
        description: "ASKELIE AI Assistant",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "ASKELIE.ASKELIE_MAIN.MAIN",
            tabDisplayName: "Askelie",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a1978667e20a2566eda2c1",
    code: "RAISE_TICKET",
    name: "RAISE TICKET",
    description: "Raise support ticket from contract view",
    isMandatory: false,
    features: [
      {
        id: "69a1979267e20a2566eda2c4",
        moduleId: "69a1978667e20a2566eda2c1",
        moduleCode: "RAISE_TICKET",
        code: "RAISE_TICKET_MAIN",
        name: "Raise Ticket from Contract View",
        description: "Raise Ticket from Contract View",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "RAISE_TICKET.RAISE_TICKET_MAIN.MAIN",
            tabDisplayName: "Raise Ticket",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a1978667e20a2566eda2c2",
    code: "HEALTH_MONITOR",
    name: "HEALTH MONITOR",
    description: "System health monitoring and alerts",
    isMandatory: false,
    features: [
      {
        id: "69a1979267e20a2566eda2c5",
        moduleId: "69a1978667e20a2566eda2c2",
        moduleCode: "HEALTH_MONITOR",
        code: "HEALTH_MONITOR_MAIN",
        name: "System Health Monitor",
        description: "System Health Monitor",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "HEALTH_MONITOR.HEALTH_MONITOR_MAIN.MAIN",
            tabDisplayName: "Health Monitor",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a690f3750f2d0bbe6513ec",
    code: "AUDIT_LOGS",
    name: "Audit Logs",
    description: "Audit Logs",
    isMandatory: false,
    features: [
      {
        id: "69a690fe750f2d0bbe6513f2",
        moduleId: "69a690f3750f2d0bbe6513ec",
        moduleCode: "AUDIT_LOGS",
        code: "AUDIT_LOGS",
        name: "Audit Log",
        description: "Audit Log",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "AUDIT_LOGS.AUDIT_LOGS.MAIN",
            tabDisplayName: "Audit Logs",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a690f7750f2d0bbe6513ed",
    code: "SYSTEM_CALENDAR",
    name: "SYSTEM CALENDAR",
    description: "Calendar",
    isMandatory: false,
    features: [
      {
        id: "69a95d5c5f8391600ab4d43b",
        moduleId: "69a690f7750f2d0bbe6513ed",
        moduleCode: "SYSTEM_CALENDAR",
        code: "SYSTEM_CALENDAR_FILTER",
        name: "System Calendar Filter",
        description: "System calender filters",
        featureType: "DROPDOWN",
        tabMappings: [
          {
            tabName: "SYSTEM_CALENDAR.SYSTEM_CALENDAR_FILTER.MAIN",
            tabDisplayName: "System Calendar",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1807",
            dependsOnModuleCode: "CONTRACT",
            description: "Contract is required for Contract type filter",
            isMandatory: true
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180c",
            dependsOnModuleCode: "SERVICE_MANAGER",
            description: "Service Manager is required",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Supplier is required",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Customer is required",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c00266212236d5c1815",
            dependsOnModuleCode: "SLA",
            description: "SLA is required",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961c02266212236d5c1819",
            dependsOnModuleCode: "GOVERNANCE",
            description: "Governance is required",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69a690f9750f2d0bbe6513f1",
    code: "DOCUMENT_SIGNATURE",
    name: "Document Signature",
    description: "Module to check signed documents status",
    isMandatory: false,
    features: [
      {
        id: "69a6910d750f2d0bbe6513f8",
        moduleId: "69a690f9750f2d0bbe6513f1",
        moduleCode: "DOCUMENT_SIGNATURE",
        code: "DOCUMENT_SIGNATURE",
        name: "Document Signature",
        description: "Feature to check signed documents status",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "DOCUMENT_SIGNATURE.DOCUMENT_SIGNATURE.MAIN",
            tabDisplayName: "Document Signature",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [
          {
            dependsOnModuleId: "69961bfc266212236d5c1808",
            dependsOnModuleCode: "CONTRACT_STUDIO",
            description: "To create Document Signature Contract Studio is required",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180b",
            dependsOnModuleCode: "SUPPLIER",
            description: "Supplier MOU requires Document Signature",
            isMandatory: false
          },
          {
            dependsOnModuleId: "69961bfd266212236d5c180a",
            dependsOnModuleCode: "CUSTOMER",
            description: "Customer Profile requires Document Signature",
            isMandatory: false
          }
        ],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  },
  {
    id: "69afc308640c6a2fd0e75a27",
    code: "COST_CENTER",
    name: "Cost Center",
    description: "Collection of modules COMMODITY LOCATION USER_TO_BILL",
    isMandatory: false,
    features: [
      {
        id: "69b1227b2378b1a32519c2d5",
        moduleId: "69afc308640c6a2fd0e75a27",
        moduleCode: "COST_CENTER",
        code: "COST_CENTER_COMMODITY",
        name: "Commodity Management",
        description: "Commodity management for cost centers",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "COST_CENTER.COST_CENTER_COMMODITY.MAIN",
            tabDisplayName: "Commodity",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69b1227b2378b1a32519c2d6",
        moduleId: "69afc308640c6a2fd0e75a27",
        moduleCode: "COST_CENTER",
        code: "COST_CENTER_LOCATION",
        name: "Location Management",
        description: "Location management for cost centers",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "COST_CENTER.COST_CENTER_LOCATION.MAIN",
            tabDisplayName: "Location",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      },
      {
        id: "69b1227b2378b1a32519c2d7",
        moduleId: "69afc308640c6a2fd0e75a27",
        moduleCode: "COST_CENTER",
        code: "COST_CENTER_USER_TO_BILL",
        name: "User to Bill Management",
        description: "User to Bill management for cost centers",
        featureType: "TABS",
        tabMappings: [
          {
            tabName: "COST_CENTER.COST_CENTER_USER_TO_BILL.MAIN",
            tabDisplayName: "User to Bill",
            displayOrder: 1,
            icon: null
          }
        ],
        dependencies: [],
        isMandatory: false,
        isActive: true,
        createdAt: null,
        updatedAt: null
      }
    ]
  }
];
